export default [
  {
    path: "/branchacademy-dashboard",
    name: "branchacademy-main",
    component: () => import("../../modules/BranchAcademy/BranchAcademy.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["branchacademy", "academy"],
    },
  },
];
